/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedAuctionActionBinAndBid_item = {
    readonly relevantAuctionSolution: {
        readonly hasReserve: boolean | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PriceDisplay_item" | "useAuctionPricing_item" | "PdpSharedPurchaseButton_item" | "PdpSharedAuctionCountdownLazy_item">;
    readonly " $refType": "PdpSharedAuctionActionBinAndBid_item";
};
export type PdpSharedAuctionActionBinAndBid_item$data = PdpSharedAuctionActionBinAndBid_item;
export type PdpSharedAuctionActionBinAndBid_item$key = {
    readonly " $data"?: PdpSharedAuctionActionBinAndBid_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedAuctionActionBinAndBid_item">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "page",
    "value": "pdp"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionActionBinAndBid_item",
  "selections": [
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "AuctionSolution",
      "kind": "LinkedField",
      "name": "relevantAuctionSolution",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasReserve",
          "storageKey": null
        }
      ],
      "storageKey": "relevantAuctionSolution(page:\"pdp\")"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "PriceDisplay_item"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "useAuctionPricing_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPurchaseButton_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionCountdownLazy_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();
(node as any).hash = '43676526020b3fbe6e4e3db68a8b3702';
export default node;
